import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import NavMenu from './components/NavMenu.vue';
import Contacts from './views/basic/Contacts.vue';
import Contact from './views/basic/Contact.vue';
import ServiceAppointments from './views/basic/ServiceAppointments.vue';
import ServiceAppointment from './views/basic/ServiceAppointment.vue';
import Filters from './views/Filters.vue';
import OperationLogs from './views/OperationLogs.vue';
import Ext from './views/biz/Ext.vue';
import ExtFields from './views/biz/ExtFields.vue';
import ExtForm from './views/biz/ExtForm.vue';
import ExtFormDetail from './views/biz/ExtFormDetail.vue';
import Preferences from './views/Preferences.vue';
import Function from './views/Function.vue';
import Role from './views/Role.vue';
import TenantMultiple from './views/TenantMultiple.vue';
import OrgUser from './views/OrgUser.vue';
import Tenant from './views/Tenant.vue';
import Code from './views/Code.vue';
import Workflows from './views/Workflows.vue';
import Workflow from './views/Workflow.vue';
import Notice from './views/Notice.vue';
import NoticeTemplate from './views/NoticeTemplate.vue';
import Notifications from './views/Notifications';
import Companys from './views/basic/Companys.vue';
import Company from './views/basic/Company.vue';
import Addresses from './views/basic/Addresses.vue';
import Address from './views/basic/Address.vue';
import TenantBilling from './views/TenantBilling.vue';
import Declaration from './views/Declaration.vue';
import DeclarationForm from './views/DeclarationForm.vue';
import OrderList from './views/basic/OrderList.vue';
import Agency from './views/Agency.vue';
import GroovyScript from './views/GroovyScript';
import GroovyScriptParam from './views/GroovyScriptParam';
import Allot from './views/automate/Allot.vue';
import CC from './views/automate/CC.vue';
import Dispatch from './views/automate/Dispatch.vue';
import SmartRules from './views/automate/SmartRules.vue';
import Materials from './views/basic/Materials.vue';
import Material from './views/basic/Material.vue';
import Products from './views/basic/Products.vue';
import Product from './views/basic/Product.vue';
import ProductInventoryItems from './views/basic/ProductInventoryItems.vue';
import NoticeTemplateManage from './views/NoticeTemplateManage.vue';
import DocManage from './views/basic/DocManage.vue';
import FAQManage from './views/basic/FAQManage.vue';
import NoticeManage from './views/basic/NoticeManage.vue';
import Dispatcher from './views/Dispatcher.vue';
import Partners from './views/basic/Partners.vue';
import Partner from './views/basic/Partner.vue';
import ServiceResources from './views/basic/ServiceResources.vue';
import ServiceResource from './views/basic/ServiceResource.vue';
import WorkTypes from './views/basic/WorkTypes.vue';
import WorkType from './views/basic/WorkType.vue';
import ServiceTerritories from './views/basic/ServiceTerritories.vue';
import ServiceTerritory from './views/basic/ServiceTerritory.vue';
import Dashboards from './views/biz/Dashboards.vue';
import Reports from './views/biz/Reports.vue';
import Personalize from './views/Personalize.vue';
import Coupons from './views/basic/Coupons.vue';
import Coupon from './views/basic/Coupon.vue';
import CouponPrinting from './views/basic/CouponPrinting.vue';
import Account from './views/Account.vue';
import Warrantys from './views/basic/Warrantys.vue';
import Warranty from './views/basic/Warranty.vue';
import NewPayments from './views/basic/NewPayments.vue';
import paymentDetail from './views/basic/paymentDetail.vue';
import PaymentRecords from './views/basic/PaymentRecords.vue';
import FinancialAudit from './views/basic/FinancialAudit.vue';
import SettleRules from './views/basic/SettleRules.vue';
import Settles from './views/basic/Settles.vue';
import Settle from './views/basic/Settle.vue';
import SettlePays from './views/basic/SettlePays.vue';
import Contracts from './views/basic/Contracts.vue';
import Contract from './views/basic/Contract.vue';
import Procedures from './views/biz/Procedures.vue';
import Procedure from './views/biz/Procedure.vue';
import ProjPackage from './views/biz/ProjPackage.vue';
import ProjPackages from './views/biz/ProjPackages.vue';
import Archive from './views/Archive.vue';

const Leads = () => import('./views/basic/Leads.vue');
// const Lead = () => import('./views/basic/Lead.vue');

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      component: resolve => require(['./views/error404.vue'], resolve)
    },
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/navmenu',
      name: 'navmenu',
      component: NavMenu,
      children: [
        //客户列表
        {
          path: '/contacts',
          name: 'contacts',
          component: Contacts
        },
        //客户
        {
          path: '/contact/:id',
          name: 'contact',
          component: Contact
        },
        //售后工单列表
        {
          path: '/WorkOrders',
          name: 'WorkOrders',
          component: () => import('./views/basic/WorkOrders.vue')
        },
        //服务工单列表
        {
          path: '/ServiceAppointments',
          name: 'ServiceAppointments',
          component: ServiceAppointments
        },
        //服务工单详情
        {
          path: '/ServiceAppointment/:id',
          name: 'ServiceAppointment',
          component: ServiceAppointment
        },
        // 项目管理
        {
          path: '/Projects',
          name: 'projects',
          component: () => import('./views/basic/Projects.vue')
        },
        // 项目详情
        {
          path: '/Project/:id',
          name: 'project',
          component: () => import('./views/basic/Project.vue')
        },
        //服务资源
        {
          path: '/ServiceResources',
          name: 'ServiceResources',
          component: ServiceResources
        },
        //服务资源详情
        {
          path: '/ServiceResource/:id',
          name: 'ServiceResource',
          component: ServiceResource
        },
        //工作类型
        {
          path: '/WorkTypes',
          name: 'WorkTypes',
          component: WorkTypes
        },
        //工作类型详情
        {
          path: '/WorkType/:id',
          name: 'WorkType',
          component: WorkType
        },
        //已保存过滤器
        {
          path: '/filters',
          name: 'filters',
          component: Filters
        },
        //系统操作日志
        {
          path: '/OperationLogs',
          name: 'operationLogs',
          component: OperationLogs
        },
        //系统扩展定义
        {
          path: '/Ext',
          name: 'ext',
          component: Ext
        },
        //系统属性管理
        {
          path: '/ExtFields',
          name: 'extFields',
          component: ExtFields
          // ExtFields
        },
        //动态表单
        {
          path: '/ExtForm/:colName',
          name: 'extForm',
          component: ExtForm
        },
        //动态表单详情页
        {
          path: '/ExtFormDetail/:colName/:id',
          name: 'extFormDetail',
          component: ExtFormDetail
        },
        //动态表单-树形数据
        {
          path: '/ExtTreeTable/:colName',
          name: 'extTreeTable',
          component: () => import('./views/biz/ExtTreeTable.vue')
        },
        // 文件模板
        {
          path: '/DocumentTemplates',
          name: 'DocumentTemplates',
          component: () => import('./views/biz/DocumentTemplates.vue')
        },
        //个人中心
        {
          path: '/Preferences',
          name: 'preferences',
          component: Preferences
        },
        //功能注册
        {
          path: '/Function',
          name: 'function',
          component: Function
        },
        //角色管理
        {
          path: '/Role',
          name: 'role',
          component: Role
        },
        //租户管理批量新增删除
        {
          path: '/TenantMultiple',
          name: 'TenantMultiple',
          component: TenantMultiple
        },
        //组织用户
        {
          path: '/OrgUser',
          name: 'orgUser',
          component: OrgUser
        },
        //租户管理
        {
          path: '/Tenant',
          name: 'tenant',
          component: Tenant
        },
        //字典管理
        {
          path: '/Code',
          name: 'code',
          component: Code
        },
        //工作流列表
        {
          path: '/Workflows',
          name: 'workflows',
          component: Workflows
        },
        //工作流配置
        {
          path: '/Workflow/:id',
          name: 'workflow',
          component: Workflow
        },
        //通用工作流列表
        {
          path: '/Flows',
          name: 'Flows',
          component: () => import('./views/Flows.vue')
        },
        //通用工作流详情
        {
          path: '/Flow/:colName/:id',
          name: 'Flow',
          component: () => import('./views/Flow.vue')
        },
        // 通知模板
        {
          path: '/NoticeTemplate/',
          name: 'NoticeTemplate',
          component: NoticeTemplate
        },
        //模板管理管理
        {
          path: '/NoticeTemplateManage',
          name: 'noticeTemplateManage',
          component: NoticeTemplateManage
        },
        //通知服务
        {
          path: '/Notice/',
          name: 'notice',
          component: Notice
        },
        //通知记录
        {
          path: '/Notifications/',
          name: 'notifications',
          component: Notifications
        },
        //公司列表
        {
          path: '/Companys',
          name: 'Companys',
          component: Companys
        },
        //公司详情
        {
          path: '/Company/:id',
          name: 'Company',
          component: Company
        },
        //地址
        {
          path: '/Addresses',
          name: 'Addresses',
          component: Addresses
        },
        //地址详情
        {
          path: '/Address/:id',
          name: 'Address',
          component: Address
        },
        //租户计费
        {
          path: '/TenantBilling',
          name: 'TenantBilling',
          component: TenantBilling
        },
        //报单
        {
          path: '/Declaration',
          name: 'Declaration',
          component: Declaration
        },
        //脚本配置
        {
          path: '/GroovyScript',
          name: 'GroovyScript',
          component: GroovyScript
        },
        //脚本配置
        {
          path: '/GroovyScriptParam/:id/:name',
          name: 'GroovyScriptParam',
          component: GroovyScriptParam
        },
        //自动分单
        {
          path: '/automate/Allot/:id',
          name: 'Allot',
          component: Allot
        },
        //自动派单
        {
          path: '/automate/Dispatch/:id',
          name: 'Dispatch',
          component: Dispatch
        },
        //自动抄送
        {
          path: '/automate/CC/:id',
          name: 'CC',
          component: CC
        },
        //智能规则
        {
          path: '/automate/SmartRules/:id',
          name: 'SmartRules',
          component: SmartRules
        },
        //订单列表
        {
          path: '/OrderList',
          name: 'OrderList',
          component: OrderList
        },
        //代理商管理
        {
          path: '/Agency',
          name: 'Agency',
          component: Agency
        },
        //FAQ
        {
          path: '/FAQManage',
          name: 'FAQManage',
          component: FAQManage
        },
        //文档管理
        {
          path: '/DocManage',
          name: 'DocManage',
          component: DocManage
        },
        //企业公告
        {
          path: '/NoticeManage',
          name: 'NoticeManage',
          component: NoticeManage
        },
        //材料列表
        {
          path: '/Materials',
          name: 'Materials',
          component: Materials
        },
        //材料详情
        {
          path: '/Material/:id',
          name: 'Material',
          component: Material
        },
        //产品列表
        {
          path: '/Products',
          name: 'Products',
          component: Products
        },
        //商品列表
        {
          path: '/Commodities',
          name: 'Commodities',
          component: () => import('./views/basic/Commodities.vue')
        },
        // 工序管理
        {
          path: '/Procedures',
          name: 'Procedures',
          component: Procedures
        },
        // 工序列表详情页
        {
          path: '/Procedure/:id',
          name: 'Procedure',
          component: Procedure
        },
        // 机措管理
        {
          path: '/Measures',
          name: 'Measures',
          component: () => import('./views/biz/Measures.vue')
        },
        // 机措列表详情页
        {
          path: '/Measure/:id',
          name: 'Measure',
          component: () => import('./views/biz/Measure.vue')
        },
        // 套餐管理
        {
          path: '/ProjPackages',
          name: 'ProjPackages',
          component: ProjPackages
        },
        // 套餐管理详情
        {
          path: '/ProjPackage/:id',
          name: 'ProjPackage',
          component: ProjPackage
        },
        //产品详情
        {
          path: '/Product/:id',
          name: 'Product',
          component: Product
        },
        //产品库
        {
          path: '/ProductInventoryItems',
          name: 'ProductInventoryItems',
          component: ProductInventoryItems
        },
        //调度中心
        {
          path: '/Dispatcher',
          name: 'Dispatcher',
          component: Dispatcher
        },
        //伙伴
        {
          path: '/Partners',
          name: 'Partners',
          component: Partners
        },
        //伙伴详情
        {
          path: '/Partner/:id',
          name: 'Partner',
          component: Partner
        },
        //服务区域
        {
          path: '/ServiceTerritories',
          name: 'ServiceTerritories',
          component: ServiceTerritories
        },
        //服务区域日志
        {
          path: '/ServiceHistory',
          name: 'ServiceHistory',
          component: () => import('./views/basic/ServiceHistory.vue')
        },
        //服务区域详情
        {
          path: '/ServiceTerritory/:id',
          name: 'ServiceTerritory',
          component: ServiceTerritory
        },
        //看板
        {
          path: '/Dashboards',
          name: 'Dashboards',
          component: Dashboards
        },
        //新-看板
        {
          path: '/DashboardNew',
          name: 'DashboardNew',
          component: () => import('./views/biz/DashboardNew.vue')
        },
        //报表库
        {
          path: '/Reports',
          name: 'Reports',
          component: Reports
        },
        //统计定义
        {
          path: '/ReportDef',
          name: 'ReportDef',
          component: () => import('./views/biz/ReportDef.vue')
        },
        //统计图表定义
        {
          path: '/ReportPalette',
          name: 'ReportPalette',
          component: () => import('./views/biz/ReportPalette.vue')
        },
        //企业公告
        {
          path: '/Archive',
          name: 'Archive',
          component: Archive
        },
        //个性化配置
        {
          path: '/Personalize',
          name: 'Personalize',
          component: Personalize
        },
        //优惠券
        {
          path: '/Coupons',
          name: 'Coupons',
          component: Coupons
        },
        //优惠券详情
        {
          path: '/Coupon/:id',
          name: 'Coupon',
          component: Coupon
        },
        //优惠券
        {
          path: '/CouponPrinting',
          name: 'CouponPrinting',
          component: CouponPrinting
        },
        //质保管理
        {
          path: '/Warrantys',
          name: 'Warrantys',
          component: Warrantys
        },
        //质保管理详情
        {
          path: '/Warranty/:id',
          name: 'Warranty',
          component: Warranty
        },

        //新增支付
        {
          path: '/NewPayments',
          name: 'NewPayments',
          component: NewPayments
        },
        //支付明细
        {
          path: '/paymentDetail/:id',
          name: 'paymentDetail',
          component: paymentDetail
        },
        //支付记录
        {
          path: '/PaymentRecords',
          name: 'PaymentRecords',
          component: PaymentRecords
        },
        //财务审核
        {
          path: '/FinancialAudit',
          name: 'FinancialAudit',
          component: FinancialAudit
        },
        // 结算政策
        {
          path: '/SettleRules',
          name: 'SettleRules',
          component: SettleRules
        },
        // 结算单列表
        {
          path: '/Settles',
          name: 'Settles',
          component: Settles
        },
        // 结算单详情
        {
          path: '/Settle/:id',
          name: 'Settle',
          component: Settle
        },
        // 付款单列表
        {
          path: '/SettlePays',
          name: 'SettlePays',
          component: SettlePays
        },
        //未结算汇总页面
        {
          path: '/SettleGather',
          name: 'SettleGather',
          component: () => import('./views/basic/SettleGather.vue')
        },
        //已结算记录
        {
          path: '/unSettleGather',
          name: 'unSettleGather',
          component: () => import('./views/basic/unSettleGather.vue')
        },
        //合同管理
        {
          path: '/Contracts',
          name: 'Contracts',
          component: Contracts
        },
        //合同管理详情
        {
          path: '/Contract/:id',
          name: 'Contract',
          component: Contract
        },
        //线索
        {
          path: '/Leads',
          name: 'Leads',
          component: Leads
        },
        //线索详情
        {
          path: '/Lead/:id',
          name: 'Lead',
          component: () => import('./views/basic/Lead.vue')
        },
        //获客码管理
        {
          path: '/Channel',
          name: 'Channel',
          component: () => import('./views/Channel.vue')
        },
        //访客管理
        {
          path: '/ZUser',
          name: 'ZUser',
          component: () => import('./views/basic/ZUser.vue')
        },
        //门店码管理（高级）
        {
          path: '/Spread',
          name: 'Spread',
          component: () => import('./views/basic/Spread.vue')
        },
        //中间号使用记录
        {
          path: '/PrivateNumberRecord',
          name: 'PrivateNumberRecord',
          component: () => import('./views/PrivateNumberRecord.vue')
        },
        //售后工单列表
        {
          path: '/AfterSaleServiceAppointments',
          name: 'AfterSaleServiceAppointments',
          component: () => import('./views/basic/AfterSaleServiceAppointments.vue')
        },
        //售后工单详情
        {
          path: '/AfterSaleServiceAppointment/:id',
          name: 'AfterSaleServiceAppointment',
          component: () => import('./views/basic/AfterSaleServiceAppointment.vue')
        },
        //周期计划
        {
          path: '/CyclePlans',
          name: 'CyclePlans',
          component: () => import('./views/basic/CyclePlans.vue')
        },
        //周期计划模板
        {
          path: '/CyclePlanTemplates',
          name: 'CyclePlanTemplates',
          component: () => import('./views/basic/CyclePlanTemplates.vue')
        },
        //优惠券领取列表
        {
          path: '/CouponPrintings',
          name: 'CouponPrintings',
          component: () => import('./views/basic/CouponPrintings.vue')
        },
        //罚款列表
        {
          path: '/Forfeit',
          name: 'Forfeit',
          component: () => import('./views/basic/Forfeit.vue')
        },
        //仓库管理列表
        {
          path: '/Warehouses',
          name: 'warehouses',
          component: () => import('./views/basic/Warehouses.vue')
        },
        //仓库管理详情
        {
          path: '/Warehouse/:id',
          name: 'warehouse',
          component: () => import('./views/basic/Warehouse.vue')
        },
        //库存管理列表
        {
          path: '/Inventories',
          name: 'inventories',
          component: () => import('./views/basic/Inventories.vue')
        },
        //库存管理详情
        {
          path: '/Inventory/:id',
          name: 'inventory',
          component: () => import('./views/basic/Inventory.vue')
        },
        //入库、出库、出入库明细
        {
          path: '/InventoryItems',
          name: 'inventoryItems',
          component: () => import('./views/basic/InventoryItems.vue')
        },
        //入库、出库、出入库明细 详情
        {
          path: '/InventoryItem/:id',
          name: 'inventoryItem',
          component: () => import('./views/basic/InventoryItem.vue')
        },
        //服务协议列表
        {
          path: '/ServiceAgreements',
          name: 'serviceAgreements',
          component: () => import('./views/basic/ServiceAgreements.vue')
        },
        //服务协议-详情页
        {
          path: '/ServiceAgreement/:id',
          name: 'serviceAgreement',
          component: () => import('./views/basic/ServiceAgreement.vue')
        },
        //参数列表
        {
          path: '/Parameter',
          name: 'Parameter',
          component: () => import('./views/basic/Parameter.vue')
        },
        //NPS列表
        {
          path: '/NetPromoterScore',
          name: 'NetPromoterScore',
          component: () => import('./views/basic/NetPromoterScore.vue')
        },
        //跟进记录
        {
          path: '/FollowingUpNote',
          name: 'FollowingUpNote',
          component: () => import('./views/basic/FollowingUpNote.vue')
        },
        //目标管理
        {
          path: '/Goals',
          name: 'Goals',
          component: () => import('./views/basic/Goals.vue')
        },
        //任务下载列表
        {
          path: '/Stask',
          name: 'Stask',
          component: () => import('./views/basic/Stask.vue')
        },
        //系统配置
        {
          path: '/Config',
          name: 'Config',
          component: () => import('./views/Config.vue')
        },
        //新手向导
        {
          path: '/NoviceWizard',
          name: 'NoviceWizard',
          component: () => import('./views/NoviceWizard.vue')
        },
        //导入
        {
          path: '/Import',
          name: 'Import',
          component: () => import('./views/Import.vue')
        },
        //闭水质保卡产品列表
        {
          path: '/WarrantyProducts',
          name: 'WarrantyProducts',
          component: () => import('./views/basic/WarrantyProducts.vue')
        },
        // 闭水质保卡产品
        {
          path: '/WarrantyProduct/:id',
          name: 'WarrantyProduct',
          component: () => import('./views/basic/WarrantyProduct.vue')
        },
        //闭水质保卡库存列表
        {
          path: '/WarrantyProductInventorys',
          name: 'WarrantyProductInventorys',
          component: () => import('./views/basic/WarrantyProductInventorys.vue')
        },
        // 闭水质保卡库存列表
        {
          path: '/WarrantyProductInventory/:id',
          name: 'WarrantyProductInventory',
          component: () => import('./views/basic/WarrantyProductInventory.vue')
        },
        //闭水质保卡订单列表
        {
          path: '/warrantyOrder',
          name: 'warrantyOrder',
          component: () => import('./views/basic/warrantyOrder.vue')
        },
        //闭水出险质保列表
        {
          path: '/AccidentWarrantys',
          name: 'AccidentWarrantys',
          component: () => import('./views/basic/AccidentWarrantys.vue')
        },
        //闭水出险质保
        {
          path: '/AccidentWarranty/:id',
          name: 'AccidentWarranty',
          component: () => import('./views/basic/AccidentWarranty.vue')
        },
        //质保库矩阵
        {
          path: '/WarrantyItems',
          name: 'WarrantyItems',
          component: () => import('./views/basic/WarrantyItems.vue')
        },
        //质保库审核
        {
          path: '/WarrantyItemAudit',
          name: 'WarrantyItemAudit',
          component: () => import('./views/basic/WarrantyItemAudit.vue')
        },
        //质保库审核
        {
          path: '/WarrantyItemHistory',
          name: 'WarrantyItemHistory',
          component: () => import('./views/basic/WarrantyItemHistory.vue')
        },
        //SLA
        {
          path: '/SLAs',
          name: 'SLAs',
          component: () => import('./views/SLAs.vue')
        },
        //SLA详情
        {
          path: '/SLA/:id',
          name: 'SLA',
          component: () => import('./views/SLA.vue')
        },
        //契约锁PDF管理
        {
          path: '/qiyuesuoPDF',
          name: 'qiyuesuoPDF',
          component: () => import('./views/qiyuesuoPDF.vue')
        },
        //中续号管理
        {
          path: '/WinnerLooks',
          name: 'WinnerLooks',
          component: () => import('./views/basic/WinnerLooks.vue')
        },
        //中续号详情管理
        {
          path: '/WinnerLook/:id',
          name: 'WinnerLook',
          component: () => import('./views/basic/WinnerLook.vue')
        },
        //坐席管理
        {
          path: '/SobotAgents',
          name: 'SobotAgents',
          component: () => import('./views/SobotAgents.vue')
        },
        // 聊天
        {
          path: '/Chat',
          name: 'Chat',
          component: () => import('./views/Chat.vue')
        },
        // 意见反馈
        {
          path: '/Suggest',
          name: 'Suggest',
          component: () => import('./views/basic/Suggest.vue')
        },
        // 移动端租户配置
        {
          path: '/tenantConfigMobile',
          name: 'tenantConfigMobile',
          component: () => import('./views/tenantConfigMobile.vue')
        },
        // 函数库
        {
          path: '/DefinedFunction',
          name: 'DefinedFunction',
          component: () => import('./views/DefinedFunction.vue')
        },
        // 家装客户
        {
          path: '/ContactFixs',
          name: 'ContactFixs',
          component: () => import('./views/basic/ContactFixs.vue')
        }
      ]
    },
    // UD单点登录
    {
      path: '/SingleSignOn',
      name: 'SingleSignOn',
      component: () => import('./views/basic/SingleSignOn.vue')
    },
    // UD综合大表单呼入
    {
      path: '/IncomingCall',
      name: 'IncomingCall',
      component: () => import('./views/basic/IncomingCall.vue')
    },
    //移动端报单页面
    {
      path: '/DeclarationForm/:id',
      component: DeclarationForm
    },
    //账号登陆页
    {
      path: '/Account',
      component: Account
    },
    //模板市场
    {
      path: '/Templates',
      name: 'templates',
      component: () => import('./views/Templates.vue')
    },
    // 在线Excel
    // {
    //   path: '/Excel',
    //   name: 'Excel',
    //   component: () => import('./views/biz/Excel.vue')
    // },
    // 表单设计器
    {
      path: '/FormDesigner',
      name: 'FormDesigner',
      component: () => import('./views/biz/FormDesigner.vue')
    },
    // 工单表单
    {
      path: '/ServiceAppointmentForm',
      name: 'ServiceAppointmentForm',
      component: () => import('./views/basic/ServiceAppointmentForm.vue')
    },
    // 雨虹防水结算单点登录
    {
      path: '/yhfs_sso',
      name: 'yhfs_sso',
      component: () => import('./views/privatization/yhfs/SSO.vue')
    }
  ]
});
